import { Box, Typography, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import { radius } from '~/styles/tokens/shape';

type PaymentJourneyStepCardProps = {
  title: string;
  stepLabel: string;
  children: ReactNode;
};

export default function PaymentJourneyStepCard({ title, stepLabel, children }: PaymentJourneyStepCardProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: `${radius.medium}px`,
        boxShadow: '0px 1px 1px rgba(0,0,0,0.3), 0px 2px 3px rgba(0,0,0,0.15)',
        mb: '32px',
        overflow: 'hidden',
        width: '100%'
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          gap: theme.spacing(1),
          justifyContent: 'space-between',
          minHeight: 64,
          px: '16px',
          py: '8px',
          width: '100%'
        }}
      >
        <Typography component="h2" sx={{ fontWeight: 600 }} variant="h6">
          {title}
        </Typography>
        <Box
          sx={{
            bgcolor: 'customColors.backgroundTertiary',
            borderRadius: `${radius.medium}px`,
            px: 2,
            py: 0.5
          }}
        >
          <Typography sx={{ fontWeight: 600 }} variant="h6">
            {stepLabel}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ pb: '24px', pt: 0, px: '24px' }}>{children}</Box>
    </Box>
  );
}
